





































































































































































import {Vue, Component, Watch, Mixins} from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import MallsTab from '@/components/common/MallsTab.vue';
import TuiTree from './GroupsTuiTree.vue';
import {PopupRequestData} from '@/types';
import {i18nObjectByKey} from '@/utils/i18n';
import {Mall, GetMailTemplatesAutoGroupsRequest, GetMailTemplatesAutoTemplatesRequest, PutMailTemplatesAutoTemplatesRequest, PostMailTemplatesAutoTemplatesTestRequest, AutoEmailTemplateType, GetMailTemplatesAutoTemplatesResponse} from 'supporter';
import {namespace, State} from 'vuex-class';
import {Admin} from '@/types';
import TermsTemplateNotice from '@/components/member/layer/TermsTemplateNotice.vue';
import AdSmsNotice from '@/components/member/layer/AdSmsNotice.vue';
import OauthTypeNotice from '@/views/member/popup/OauthTypeNotice.vue';
import PopUpAdNoticeMixin from '@/views/member/mixins/PopUpAdNoticeMixin.vue';
const adminModule = namespace('admin');
const mallModule = namespace('mall');
@Component({
  components: {
	  OauthTypeNotice,
    AdSmsNotice,
    TermsTemplateNotice,
    PageTitle,
    MallsTab,
    TuiTree
  }
})
export default class AutoMail extends Mixins(PopUpAdNoticeMixin) {
  @mallModule.Action('fetchMalls') fetchMalls!: () => Promise<any>;
  @State('malls', {namespace: 'mall'})
  private malls!: Mall[];
  @adminModule.Getter('admin') private admin!: Admin;
  private theData: any[] = [];
  private mallNo: number = 1;
  private selectNum: number = 1;
  private emailUsed: boolean = false;
  private isChange: boolean = false;
  private isShowHelp: boolean = false;
  private isShowTermsNotice = false;
  private isShowAdNotice = false;
  private selectDate: GetMailTemplatesAutoTemplatesResponse = {
    senderMailType: '',
    name: '',
    used: true,
    title: '',
    type: '',
    content: ''
  };
  private selectForm = {
    isDefaultTemplate: true,
    senderMailType: '',
    name: '',
    used: true,
    title: '',
    type: '',
    content: '',
    parentData: {
      name: ''
    }
  };
  private submitBtn() {
    const tree = (this.$refs.theTree as any).tree;
    const selectedNodeId = tree.getSelectedNodeId();
    const depth = tree.getDepth(selectedNodeId);

    if (depth === null) {
      alert(this.$t('MAIL_AUTO_MAIL_SELECT_TEMPLATE'));

      return;
    }

    if (depth === 1) {
      alert(this.$t('MAIL_AUTO_MAIL_SELECT_TEMPLATE'));
    } else {
      // const mailTemplate = tree.getNodeData(selectedNodeId);
      // $(window.opener.location).attr('href', `javascript:ncp.dispatch.applyTemplate(${JSON.stringify(mailTemplate)});`);
      window.close();
    }
  }
  private cancelBtn() {
    window.close();
  }
  private tuiTreeSelect(template: any): void {
    const tree = (this.$refs.theTree as any).tree;
    this.selectNum = template.theIndex;
    if (this.selectNum === 2) {
      // if (this.selectForm.templateNo === template.theObj.templateNo) {
      //   return;
      // }
      if (this.isChange) {
        if (!confirm(`${this.$t('MAIL_AUTO_MAIL_CONFIRM_CHANGE')}`)) {
          return;
        }
        this.isChange = false;
      }
      this.selectForm = template.theObj;
      this.selectForm.parentData = template.theParentData;
    } else if (tree.getState(template.originData.nodeId) === 'closed') {
      tree.open(template.originData.nodeId);
    } else {
      tree.close(template.originData.nodeId);
    }
    // this.searchData(template.theObj.type);
  }

  private dataFormat(data: any[]): any[] {
    let newData = data.map((item) => {
      Vue.set(item, 'text', item.name);
      if (item.used) {
        Vue.set(item, 'usetemp', this.$t('MAIL_AUTO_MAIL_USE_TEMPLATE'));
      } else {
        Vue.set(item, 'usetemp', this.$t('MAIL_AUTO_MAIL_UNUSE_TEMPLATE'));
      }
      if (item.templates) {
        Vue.set(item, 'children', item.templates);
        if (item.templates.length > 0) {
          this.dataFormat(item.children);
        }
      }
      return item;
    });
    return newData;
  }
  private initData(): void {
    let theObj: GetMailTemplatesAutoGroupsRequest = {
      params: {
        mallNo: Number(this.$route.query.mallNo)
      }
    };
    this.$api.getMailTemplatesAutoGroups(theObj).then((res) => {
      this.theData = [];
      this.theData = this.dataFormat(res.data);
    });
  }

  // reset用
  private async searchData(templateType: string) {
    const request: GetMailTemplatesAutoTemplatesRequest = {
      pathParams: { templateType: templateType as AutoEmailTemplateType },
      params: { mallNo: Number(this.$route.query.mallNo) }
    };

    const { data: mailTemplate } = await this.$api.getMailTemplatesAutoTemplates(request);
  
    this.selectDate = mailTemplate;
  }

  private doSetting(): void {
    if (this.selectForm.title === '') {
      alert(this.$t('MAIL_AUTO_MAIL_ERR_TITLE_NULL'));
    } else if (this.selectForm.content === '') {
      alert(this.$t('ERR_CONTENT_NULL'));
    } else {
      this.doModifyMailTemplate();
    }
  }

  private async doModifyMailTemplate() {
    let request: PutMailTemplatesAutoTemplatesRequest = {
      pathParams: {
        templateType: this.selectForm.type as AutoEmailTemplateType
      },
      params: {
        mallNo: Number(this.$route.query.mallNo)
      },
      data: {
        usable: Boolean(this.selectForm.used),
        senderMailType: this.selectForm.senderMailType.toString(),
        title: this.selectForm.title.toString(),
        content: this.selectForm.content.toString()
      }
    };

    await this.$api.putMailTemplatesAutoTemplates(request)

    alert(this.$t('MAIL_AUTO_MAIL_CHANGE_SUCCESS'));
    this.$router.go(0);
  }

  private onTest() {
    let request: PostMailTemplatesAutoTemplatesTestRequest = {
      pathParams: {
        templateType: this.selectForm.type
      },
      params: {
        mallNo: Number(this.$route.query.mallNo)
      }
    };
    this.$api
      .postMailTemplatesAutoTemplatesTest(request)
      .then(() => {
        alert(this.$t('MAIL_AUTO_MAIL_TEST_SUCCESS', [this.admin.name]));
      })
      .catch(() => {
        // console.log('mail template test: 테스트 전송 ' + error);
        alert(this.$t('MAIL_AUTO_MAIL_ERR_TEST'));
      });
  }

  private onChange(): void {
    this.isChange = true;
  }

  private async onReset() {
    await this.searchData(this.selectForm.type);
    this.selectForm.title = this.selectDate.title;
    this.selectForm.used = this.selectDate.used;
    this.selectForm.senderMailType = this.selectDate.senderMailType;
    this.selectForm.content = this.selectDate.content;
    this.isChange = false;
  }

  private autoMailPopupRequestData: PopupRequestData = {
    id: 'mailLayerPopup',
    width: 900,
    maxHeight: 900,
    classStr: 'lp_large',
    title: 'MAIL_AUTO_MAIL_HELP_TITLE',
    hasConfirmBtn: false,
    hasCloseBtn: false,
    hasVerticalScroll: true
  };

  private toFirstPage() {
    // console.log(this.$route.query.mallNo)
    // window.location.reload();
    let url = `/mail/dispatch?mallNo=${this.mallNo}&tabNo=1`;
    window.location.assign(url);
  }

  private async configurations() {
    const configRequest = {
      params: {
        mallNo: this.mallNo
      }
    };

    await this.$api
      .getNotificationsConfigurations(configRequest)
      .then((res) => {
        this.emailUsed = res.data.emailUsed;
      })
      .catch((e: any) => {
        if (e.data.code === 'MC0002') {
          this.emailUsed = false;
        }
      });
    if (!this.emailUsed) {
      window.location.assign(`/mail/usage-list?mallNo=${this.mallNo}&tabNo=5`);
    }
  }

  @Watch('$route.query.mallNo', {immediate: false, deep: false})
  async onMallChanged() {
    if (this.$route.query.mallNo) {
      this.mallNo = Number(this.$route.query.mallNo);
    } else {
      this.mallNo = this.malls[0].mallNo;
    }
    this.toFirstPage();
    // await this.configurations();

  }


  private created() {
    this.autoMailPopupRequestData = i18nObjectByKey(this, this.autoMailPopupRequestData, 'title');
  }

  async mounted() {
    await this.fetchMalls();
    if (this.$route.query.mallNo) {
      this.mallNo = Number(this.$route.query.mallNo);
    } else {
      this.mallNo = this.malls[0].mallNo;
    }
    await this.configurations();
    this.initData();

    //this.routechange();
  }
}
